import { NgModule } from '@angular/core';
import { ReplacePipe } from 'src/app/models/pipes/replace-pipe';

@NgModule({
  declarations: [ReplacePipe],
  exports: [ReplacePipe]
})
export class ReplacePipeModule { }
